import Vue from 'vue'

export default {
  CLEAR_ALL ({ commit }) {
    commit('CLEAR_ALL')
  },
  SET_INCIDENCIA ({ commit }, incidencia) {
    commit('SET_INCIDENCIA', incidencia)
  },
  SET_ENTITY ({ state, commit }, params) {
    let entity = params.entity
    // await new Promise((resolve, reject) => {
    if (Vue.apiUrl(entity)) {
      Vue.axios({
        method: 'get',
        url: Vue.apiUrl(entity) + (params.queryString || ''),
        headers: { 'Content-Type': 'application/json' }
      })
        .then(({ data }) => {
          if (data) {
            if (!Array.isArray(data)) data = [data]
            let entityObj = {
              name: entity,
              entity: Vue.loadSelect(data, params.label, params.value, params.props)
            }
            commit('SET_ENTITY', entityObj)
          }
          // resolve(true)
        })
        .catch(() => {
          // let errorObject = JSON.parse(JSON.stringify(error))
          // resolve(true)
          // reject(error)
        })
    } // else resolve(true)
    // })
  },
  GET_ENTITY ({ state }, entity) {
    return new Promise((resolve, reject) => {
      if (state[entity]) {
        resolve(state[entity])
      } else {
        resolve([])
      }
    })
  },
  LOAD_ENTITY ({ state, dispatch }, params) {
    let entity = params.entity
    if (params.force || (!state[entity] || !state[entity].length)) {
      dispatch('SET_ENTITY', params)
    }
  },
  SET_INSTALACION ({ commit }, instalacion) {
    commit('SET_INSTALACION', instalacion)
  },
  SET_CLIENTE ({ commit }, cliente) {
    commit('SET_CLIENTE', cliente)
  }
}
